import { SignatureFieldContext } from '../../interfaces/signature';
import { SerializedFieldContext } from '../content-control-to-field-map.service';
import { ContentControlId } from '../document-monitors/content-control-id';
import { FieldType } from './field-type';

export type ContentControlDTO = ContentControlId & {
  parentId: number | null;
} & { childIds: number[] };
export type ControlFieldPairDTO = {
  contentControlDto: ContentControlDTO;
  field: {
    type: FieldType;
    context: SerializedFieldContext | SignatureFieldContext;
  };
};

export class FieldDTO {
  get templateNamespace(): string | undefined {
    return this._templateNamespace;
  }

  get templateEntity(): string {
    return this._templateEntity;
  }

  get appVersion(): string {
    return this._appVersion;
  }

  get controlFieldPairList(): ControlFieldPairDTO[] {
    return this._controlFieldPairList;
  }

  get ooxml(): string {
    return this._ooxml;
  }
  private readonly _templateNamespace: string | undefined;
  private readonly _templateEntity: string;
  private readonly _appVersion: string;
  private readonly _controlFieldPairList: ControlFieldPairDTO[];
  private readonly _ooxml: string;

  constructor(
    templateNamespace: string | undefined,
    templateEntity: string,
    appVersion: string,
    controlFieldPairs: ControlFieldPairDTO[],
    ooxml: string
  ) {
    this._templateNamespace = templateNamespace;
    this._templateEntity = templateEntity;
    this._appVersion = appVersion;
    this._controlFieldPairList = controlFieldPairs;
    this._ooxml = ooxml;
  }

  static fromJson(json: string): FieldDTO {
    const obj = JSON.parse(json) as FieldDTO;
    return new FieldDTO(obj._templateNamespace, obj._templateEntity, obj._appVersion, obj._controlFieldPairList, obj._ooxml);
  }

  getRootLevelControlFieldPairs(): ControlFieldPairDTO[] {
    return this.controlFieldPairList.filter((cfp) => cfp.contentControlDto.parentId === null);
  }

  toJson(): string {
    return JSON.stringify(this);
  }
}
